import type { GetInvoicesParams } from '@/api/invoices/types';
import { Invoices, type InvoicesType } from '@/api/schema';
import { useApiQuery } from '@/hooks/useApiQuery';
import { axiosInstance } from '@/lib/api/axios';

// POST: /invoices
const fetchInvoices = async (params: GetInvoicesParams): Promise<InvoicesType> => {
    const { data } = await axiosInstance.post('/invoices', params);
    return data;
};

export const useInvoices = (params: GetInvoicesParams) =>
    useApiQuery({
        queryKey: ['invoices', params],
        fetcher: () => fetchInvoices(params),
        validator: Invoices,
        queryOptions: {
            staleTime: 5 * 60 * 1000,
            gcTime: 30 * 60 * 1000,
        },
    });
